<!-- Claims feed -->

<div class="quote-progress__slide" id="quote-progres">
  <div class="quote-progress">
    <div class="quote-progress__content">

      <div class="progress-tree">

        @if (!event_details) {
          <div class="progress-tree__item is-inactive">
            <div class="progress-tree__branch">
              <span><span></span></span>
            </div>
            <div class="progress-tree__content">
              <div class="progress-tree__title">
                <p>Details</p>
              </div>
              <div class="progress-tree__detail">
                <div class="progress-tree__detail-track">
                  <div class="progress-tree__detail-trackfill" style="width:30%"></div>
                </div>
              </div>
            </div>
          </div>
        }

        @if (event_details) {
          <div
            class="progress-tree__item is-{{event_details?.status}}">
            <div class="progress-tree__branch">
              <span><span></span></span>
            </div>
            <div class="progress-tree__content">
              <div class="progress-tree__title">
                <p>{{event_details?.group_type}}</p>
              </div>
              @if (event_details?.entry_type !== 'event_details') {
                <div
                  class="progress-tree__detail is-{{event_details?.status}}">
                  <div class="progress-tree__detail-name" title="{{event_details?.description}}"
                  [innerHTML]="event_details?.description"></div>
                  <div class="progress-tree__detail-track">
                    <div class="progress-tree__detail-trackfill" [ngStyle]="{width:event_details?.percentage}"></div>
                  </div>
                  <div class="progress-tree__detail-actions">
                    <!--<a href="javascript:void(0);" class="action-remove text-link">Edit</a>-->
                  </div>
                </div>
              }
              @if (event_details?.entry_type === 'event_details') {
                <div
                  class="progress-tree__detail is-{{event_details?.status}}">
                  @for (item of event_details?.items; track $index) {
                    <div class="progress-tree__detail-name" title="{{item.name}}">
                      {{item.name}}
                    </div>
                    <div class="progress-tree__detail-location">
                      {{item.location}}
                    </div>
                    <div class="progress-tree__detail-date">
                      {{item.date}}
                    </div>
                    <div class="progress-tree__detail-track">
                      <div class="progress-tree__detail-trackfill" [ngStyle]="{width:event_details?.percentage}"></div>
                    </div>
                    <div class="progress-tree__detail-actions">
                      <a href="javascript:void(0);"  (click)="editItem(item)" class="action-edit text-link">Edit</a>
                    </div>
                  }
                </div>
              }
            </div>
          </div>
        }

        @if (groups?.length && groups[0]?.items?.length > 0 && cart_type === CartType.claim) {
          <div
            class="progress-tree__item is-none">
            <div class="progress-tree__branch">
              <span><span></span></span>
            </div>
            <div class="progress-tree__title">
              <p>Damage Report</p>
            </div>
          </div>
        }

        @if (groups?.length) {
        }
        @for (group of groups; track group.group_class) {
          <div class="progress-tree__item is-{{group.status}}">
            <div class="progress-tree__branch">
              <span><span></span></span>
            </div>
            <div class="progress-tree__content">
              <div class="progress-tree__title">
                <p>{{group.group_name}}</p>
              </div>
              @for (item of group.items; track item.shoppingcart_id) {
                <div (click)="activateItem(item)"
                  class="progress-tree__detail {{activeClass(item)}}" id="{{item.shoppingcart_id}}">
                  <div class="progress-tree__detail-name"
                  title="{{formatItemDescription(item.description, 1)}}">{{formatItemDescription(item.description, 1)}}</div>
                  @if (cart_type == CartType.acquisition && item.hide_prem == 0) {
                    <div class="progress-tree__detail-cost">
                      <p><strong>{{questionService?.accounting?.formatMoney(item.premium)}}</strong>
                    /{{questionService?.currency?.display_freq}}</p></div>
                  }
                  <div class="progress-tree__detail-description">{{formatItemDescription(item.description, 2)}}</div>
                  <div class="progress-tree__detail-track">
                    <div class="progress-tree__detail-trackfill" [ngStyle]="{width:getPercentage(item.progress)}"></div>
                  </div>
                  <div class="progress-tree__detail-actions">
                    @if (item.edit_flag === 1 && cart_type == CartType.acquisition) {
                      <a href="javascript:void(0);" (click)="editItem(item)" id="edit_item_sidebar_acquisition" class="action-edit text-link">Edit</a>
                    }
                    <!--<span>|</span>
                    <a href="javascript:void(0);" (click)="questionService.setSelectedItem(item)"
                    class="action-remove text-link">Remove</a>-->
                    @if (item.disc_flag === 1 && cart_type == CartType.acquisition) {
                      <div
                        class="progress-tree__detail-discounts">
                        <svg class="icon">
                          <use xlink:href="#discount-summary-mini"></use>
                        </svg>
                      </div>
                    }
                  </div>
                </div>
              }
            </div>
          </div>
        }

      </div>
      @if (cart_type == CartType.acquisition) {
        <div class="quote-progress__fees">
          <div class="quote-progress__fees-name">
            {{getEntryType('fees')[0]?.description}}
            @if (getEntryType('fees')[0]?.tooltip) {
              <a class="popover-trigger popover-trigger--hover popover-trigger--sm"
                tabindex="0" data-toggle="popover" data-trigger="focus" data-html="true"
                [attr.data-content]="buildTooltip(getEntryType('fees')[0]?.tooltip)" data-original-title="" title="">
                <svg class="icon icon--sm">
                  <use xlink:href="#help-Icon"></use>
                </svg>
              </a>
            }
          </div>
          <div class="quote-progress__fees-cost">
            <p><strong>{{questionService?.accounting?.formatMoney(getEntryType('fees')[0]?.premium)}}</strong>
          /{{getEntryType('fees')[0]?.frequency}}</p>
        </div>
      </div>
    }

  </div>
  @if (cart_type == CartType.acquisition) {
    <div class="quote-progress__subtotal">
      <div class="quote-progress__subtotal-name">
        Subtotal
      </div>
      <div class="quote-progress__subtotal-cost">
        <p>
          <strong>
            <em>{{questionService?.accounting?.formatMoney(getEntryType('subtotal')[0]?.premium)}}</em>
          </strong>/{{getEntryType('subtotal')[0]?.frequency}}
        </p>
      </div>
    </div>
  }
</div>
<!-- ./quote-progress -->
</div>


<!-- separate code for mobile claims feed -->
<div class="modal fade modal--fullscreen" id="mobile-cart" tabindex="-1" role="dialog"
  aria-labelledby="mobile-quote-menu" aria-hidden="true">
  <div class="modal-dialog" role="document">
    <div class="modal-content mobile-cart">
      <div class="modal-cart__heading">
        <div class="container">
          <h6>Quote</h6>
          <a href="javascript:void(0);" class="modal-cart__save">Save</a>
          <a href="javascript:void(0);" class="modal-cart__close" data-dismiss="modal">
            <svg class="icon">
              <use xlink:href="#close-circle-small"></use>
            </svg>
          </a>
        </div>
      </div>
      <div class="modal-cart__content">
        <div class="container">
          <div class="quote-progress">
            <div class="quote-progress__content">
              <div class="progress-tree">
                <div class="progress-tree-claims">
                  <!-- Event Details not started state-->
                  @if (!event_details) {
                    <div class="progress-tree__item is-inactive">
                      <div class="progress-tree__branch">
                        <span><span></span></span>
                      </div>
                      <div class="progress-tree__content">
                        <div class="progress-tree__title">
                          <p>Details</p>
                        </div>
                        <div class="progress-tree__track">
                          <div class="progress-tree__track-trackfill" style="width:30%"></div>
                        </div>
                        <!-- no detail yet
                        <div class="progress-tree__detail">
                        </div>
                        -->
                      </div>
                    </div>
                  }
                  @if (event_details) {
                    <div
                      class="progress-tree__item is-{{event_details?.status}}">
                      <div class="progress-tree__branch">
                        <span><span></span></span>
                      </div>
                      <div class="progress-tree__content">
                        <div class="progress-tree__title">
                          <p>{{event_details?.group_type}}</p>
                        </div>
                        <div class="progress-tree__track">
                          <div class="progress-tree__track-trackfill"
                          [ngStyle]="{'width': event_details?.percentage}"></div>
                        </div>
                        <div class="progress-tree__detail">
                          <div class="progress-tree__detail-name" title="">
                            {{event_details?.description}}
                          </div>
                        </div>
                        @if (event_details?.group_type === 'event_details' && event_details?.status === 'complete' && event_details?.items?.length) {
                          <div
                            class="progress-tree__detail">
                            @for (item of event_details?.items; track $index) {
                              <div class="progress-tree__detail-name" title="{{item.name}}">
                                {{item.name}}
                              </div>
                              <div class="progress-tree__detail-location">
                                {{item.location}}
                              </div>
                              <div class="progress-tree__detail-date">
                                {{item.date}}
                              </div>
                              <div class="progress-tree__detail-actions">
                                <a href="javascript:void(0);" (click)="editItem(item)" class="action-edit text-link">Edit</a>
                              </div>
                            }
                          </div>
                        }
                        <!-- no detail yet
                        <div class="progress-tree__detail">
                        </div>
                        -->
                      </div>
                    </div>
                  }


                  <!-- Damage Report -->
                  @if (groups.length && groups[0]?.items?.length && cart_type === CartType.claim) {
                    <div
                      class="progress-tree__item is-none">
                      <div class="progress-tree__branch">
                        <span><span></span></span>
                      </div>
                      <div class="progress-tree__title">
                        <p>Damage Report</p>
                      </div>
                    </div>
                  }


                  <!-- Vehicles block active/in progress state-->
                  @if (groups.length && groups[0]?.items?.length) {
                    @for (group of groups; track group.group_class) {
                      <div
                        class="progress-tree__item progress-tree__item--sub is-{{group.status}}">
                        <div class="progress-tree__branch">
                          <span><span></span></span>
                        </div>
                        <div class="progress-tree__content">
                          <div class="progress-tree__title">
                            <p>{{group.group_name}}</p>
                            <!-- <a href="javascript:void(0);" class="action-add text-link">+ Add</a> -->
                          </div>
                          <!-- Default state -->
                          @for (item of group.items; track item.shoppingcart_id) {
                            <div (click)="activateItem(item)"
                              class="progress-tree__detail {{activeClass(item)}}" id="{{item.shoppingcart_id}}">
                              <div class="progress-tree__detail-name"
                                title="{{formatItemDescription(item.description, 1)}}">
                                {{formatItemDescription(item.description, 1)}}
                              </div>
                              <div class="progress-tree__detail-discounts">
                                <svg class="icon">
                                  <use xlink:href="#discount-summary-mini"></use>
                                </svg>
                              </div>
                              <div class="progress-tree__detail-cost"><p>
                                <strong>{{questionService?.accounting?.formatMoney(item.premium)}}</strong>
                              /{{getEntryType('subtotal')[0]?.frequency}}</p></div>
                              <div class="progress-tree__detail-description">
                                {{formatItemDescription(item.description, 2)}}
                              </div>
                              <div
                                class="progress-tree__detail-actions is-{{getItemStatus(item.progress, item.has_skipped)}}">
                                <a
                                  href="javascript:void(0);"
                                  (click)="editClaimsItem(item)"
                                  class="action-edit text-link">
                                  Edit
                                </a>
                                <!--<span>|</span>-->
                                <!--<a href="javascript:void(0);" class="action-remove text-link">Remove</a>-->
                                <div class="progress-tree__detail-actions-notification">
                                  <span><span></span></span>
                                </div>
                              </div>
                            </div>
                          }
                        </div>
                      </div>
                    }
                  }


                  <!-- Police Report Details Not started -->
                  @if (groups.length && groups[0]?.items?.length && cart_type === CartType.claim) {
                    @if (groups.length) {
                      <div class="progress-tree__item is-inactive">
                        <div class="progress-tree__branch">
                          <span><span></span></span>
                        </div>
                        <div class="progress-tree__content">
                          <div class="progress-tree__title">
                            <p>Police Report Details</p>
                          </div>
                          <!-- no detail yet
                          <div class="progress-tree__detail">
                          </div>
                          -->
                        </div>
                      </div>
                    }
                  }

                </div>
              </div>
              @if (cart_type == CartType.acquisition) {
                <div class="quote-progress__fees">
                  <div class="quote-progress__fees-name">
                    {{getEntryType('fees')[0]?.description}}
                    @if (getEntryType('fees')[0]?.tooltip) {
                      <a
                        class="popover-trigger popover-trigger--hover popover-trigger--sm" tabindex="0"
                        data-toggle="popover" data-trigger="focus" data-html="true"
                        [attr.data-content]="buildTooltip(getEntryType('fees')[0]?.tooltip)" data-original-title=""
                        title="">
                        <svg class="icon icon--sm">
                          <use xlink:href="#help-Icon"></use>
                        </svg>
                      </a>
                    }
                  </div>
                  <div class="quote-progress__fees-cost">
                    <p><strong>{{questionService?.accounting?.formatMoney(getEntryType('fees')[0]?.premium)}}</strong>
                  /{{getEntryType('fees')[0]?.frequency}}</p>
                </div>
              </div>
            }
          </div>
        </div>
      </div>
    </div>
    <div class="modal-cart__subtotal">
      <div class="container">
        <div class="modal-cart__subtotal-title">
          {{getEntryType('subtotal')[0]?.description}}
        </div>
        <div class="modal-cart__subtotal-cost">
          <p>
            <strong><em>{{questionService?.accounting?.formatMoney(getEntryType('subtotal')[0]?.premium)}}</em></strong>
          /{{getEntryType('subtotal')[0]?.frequency}}</p>
        </div>
      </div>
    </div>
  </div>
</div>
</div>


<!-- alert modal - save claim -->
<div class="modal fade modal--alert" id="saveclaim-modal" tabindex="-1" role="dialog" aria-labelledby="saveclaim-modal"
  aria-hidden="true">
  <div class="modal-dialog" role="document">
    <div class="modal-content modal-alert modal-alert--alt">

      <div class="modal-alert__heading">
        <div class="container">
          <div class="modal-alert__avatar modal-alert__avatar--alt">
            <img src="assets/3/avatar/happy.png" class="img-fluid" alt="">
          </div>
          <button class="modal-alert__close" data-dismiss="modal">
            <svg class="icon">
              <use xlink:href="#close-medium"></use>
            </svg>
          </button>
        </div>
      </div>

      <div class="modal-alert__content">
        <div class="container">
          <div class="rte">
            <h3>We will autosave your claim as you progress.</h3>
            <p>You can find your Claim in this app’s Claim tab. Please remember to complete and submit your claim once
            you are done.</p>
          </div>
        </div>
      </div>


      <div class="modal-alert__button">
        <div class="container">
          <a href="javascript:void(0);" class="button button--lg button--secondary" data-toggle="modal"
            data-dismiss="modal">Exit
          Claim</a>
          <a href="javascript:void(0);" class="button button--lg button--primary" data-toggle="modal"
            data-dismiss="modal">Continue
          Claim</a>
        </div>
      </div>
    </div>
  </div>
</div>
<!-- /modal -->


<!-- action sheet modal (mobile only) -->
<div class="modal fade modal--tray" id="nav-action-sheet" tabindex="-1" role="dialog"
  aria-labelledby="modal-traymenu-more" aria-hidden="true">
  <div class="modal-dialog">
    <div class="modal-content modal-traymenu">
      <div class="container">
        <div class="modal-traymenu__list list-unstyled">
          <a href="#savequote-modal" data-toggle="modal" class="modal-traymenu__list-item">
            <svg class="icon">
              <use xlink:href="#bookmark"></use>
            </svg>
            <div>Save</div>
          </a>
          <a href="javascript:void(0);" class="modal-traymenu__list-item">
            <svg class="icon">
              <use xlink:href="#restart"></use>
            </svg>
            <div>Restart</div>
          </a>
          <a href="javascript:void(0);" id="chatActionTrigger" class="modal-traymenu__list-item">
            <svg class="icon">
              <use xlink:href="#chat"></use>
            </svg>
            <div>Support</div>
          </a>
        </div>

        <a href="javascript:void(0);" data-dismiss="modal" class="modal-traymenu__close">
          <svg class="icon">
            <use xlink:href="#close-medium"></use>
          </svg>
          <div>Close</div>
        </a>
      </div>
    </div>
  </div>
</div>
<!-- /modal -->


<!-- alert modal - restart -->
<div class="modal fade modal--alert" id="restart-modal" tabindex="-1" role="dialog" aria-labelledby="restart-modal"
  aria-hidden="true">
  <div class="modal-dialog" role="document">
    <div class="modal-content modal-alert modal-alert--alt">

      <div class="modal-alert__heading">
        <div class="container">
          <div class="modal-alert__avatar">
            <img src="assets/3/avatar/happy.png" class="img-fluid" alt="">
          </div>
          <a href="javascript:void(0);" class="modal-alert__close" data-dismiss="modal">
            <svg class="icon">
              <use xlink:href="#close-medium"></use>
            </svg>
          </a>
        </div>
      </div>

      <div class="modal-alert__content">
        <div class="container">
          <div class="rte">
            <h3>Are you sure you want to restart?</h3>
            <p>You will lose all you have done so far.</p>
          </div>
        </div>
      </div>


      <div class="modal-alert__button">
        <div class="container">
          <a href="javascript:void(0);" class="button button--lg button--secondary" data-toggle="modal"
            data-dismiss="modal">
            Yes, please do it
          </a>
          <a href="javascript:void(0);" class="button button--lg button--primary" data-toggle="modal"
            data-dismiss="modal">
            No, please don't
          </a>
        </div>
      </div>
    </div>
  </div>
</div>
<!-- /modal -->

<!-- alert modal - exit modal -->
<div class="modal fade modal--alert" id="exit-modal" tabindex="-1" role="dialog" aria-labelledby="exit-modal"
  aria-hidden="true">
  <div class="modal-dialog" role="document">
    <div class="modal-content modal-alert modal-alert--alt">

      <div class="modal-alert__heading">
        <div class="container">
          <div class="modal-alert__avatar">
            <img src="assets/3/avatar/happy.png" class="img-fluid" alt="">
          </div>
          <a href="javascript:void(0);" class="modal-alert__close" data-dismiss="modal">
            <svg class="icon">
              <use xlink:href="#close-medium"></use>
            </svg>
          </a>
        </div>
      </div>

      <div class="modal-alert__content">
        <div class="container">
          <div class="rte">
            <h3>We have saved your claim.</h3>
            <p>You can find your Claim in this app’s Claim tab. Please remember to complete and submit your claim once
              you are done.
            </p>
          </div>
        </div>
      </div>


      <div class="modal-alert__button">
        <div class="container">
          <a href="javascript:void(0);" class="button button--lg button--secondary" data-toggle="modal"
            data-dismiss="modal">
            Continue Claim
          </a>
          <a href="javascript:void(0);" class="button button--lg button--primary" data-toggle="modal"
            data-dismiss="modal">
            Exit Claim
          </a>
        </div>
      </div>
    </div>
  </div>
</div>
<!-- /modal -->

<!-- alert modal - save modal -->
<div class="modal fade modal--alert" id="save-modal" tabindex="-1" role="dialog" aria-labelledby="save-modal"
  aria-hidden="true">
  <div class="modal-dialog" role="document">
    <div class="modal-content modal-alert modal-alert--alt">

      <div class="modal-alert__heading">
        <div class="container">
          <div class="modal-alert__avatar">
            <img src="assets/3/avatar/happy.png" class="img-fluid" alt="">
          </div>
          <a href="javascript:void(0);" class="modal-alert__close" data-dismiss="modal">
            <svg class="icon">
              <use xlink:href="#close-medium"></use>
            </svg>
          </a>
        </div>
      </div>

      <div class="modal-alert__content">
        <div class="container">
          <div class="rte">
            <h3>We will autosave your claim as you progress.</h3>
            <p>You can find your Claim in this app’s Claim tab. Please remember to complete and submit your claim once
            you are done.</p>
          </div>
        </div>
      </div>


      <div class="modal-alert__button">
        <div class="container">
          <a href="javascript:void(0);" class="button button--lg button--secondary" data-toggle="modal"
            data-dismiss="modal">
            Exit Claim
          </a>
          <a href="javascript:void(0);" class="button button--lg button--primary" data-toggle="modal"
            data-dismiss="modal">
            Continue Claim
          </a>
        </div>
      </div>
    </div>
  </div>
</div>
<!-- /modal -->
